module.exports = __webpack_public_path__ + "img/06.a24619fe.svg";